export class AuthConfiguration {
  storageKey?: string;
  tokenRefreshThreshold: number = 10000;
}
